import actionTypes from './action-types';

// The max size of the item cache
const RECENTLY_VIEWED_MAX_LENGTH = 20;

export const initialState = {
    recentItemIds: [],
    wishListItemIds: []
};

export default (
    state = {
        ...initialState
    },
    action
) => {
    const addRecentlyViewed = () => {
        const { payload: itemId } = action;
        const { recentItemIds = [] } = state;

        // Remove item if already present
        let updatedRecentItemIds = recentItemIds.filter((x) => x !== itemId);
        // Add to front of list
        updatedRecentItemIds.unshift(itemId);
        // Limit list length
        updatedRecentItemIds = updatedRecentItemIds.slice(
            0,
            RECENTLY_VIEWED_MAX_LENGTH
        );
        return {
            ...state,
            recentItemIds: updatedRecentItemIds
        };
    };

    const setRecentlyViewed = () => {
        const { payload } = action;
        return {
            ...state,
            recentItemIds: payload.slice(0, RECENTLY_VIEWED_MAX_LENGTH)
        };
    };

    const wishlist = () => {
        const {
            payload: { itemId, exists }
        } = action;

        const wishListItemIds = new Set(state.wishListItemIds || []);
        if (exists) {
            wishListItemIds.add(itemId);
        } else {
            wishListItemIds.delete(itemId);
        }
        return {
            ...state,
            wishListItemIds: Array.from(wishListItemIds)
        };
    };

    const wishlistAddRange = () => {
        const {
            payload: { itemIds }
        } = action;
        const wishListItemIds = new Set(state.wishListItemIds || []);
        itemIds?.forEach((itemId) => wishListItemIds.add(itemId));
        return {
            ...state,
            wishListItemIds: Array.from(wishListItemIds)
        };
    };

    const wishlistRemoveRange = () => {
        const {
            payload: { itemIds }
        } = action;
        const wishListItemIds = new Set(state.wishListItemIds || []);
        itemIds?.forEach((itemId) => wishListItemIds.delete(itemId));
        return {
            ...state,
            wishListItemIds: Array.from(wishListItemIds)
        };
    };

    const initialize = () => {
        return {
            ...action.payload
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.ADD_RECENTLY_VIEWED]: addRecentlyViewed,
        [actionTypes.SET_RECENTLY_VIEWED]: setRecentlyViewed,
        [actionTypes.INITIALIZE]: initialize,
        [actionTypes.WISHLIST]: wishlist,
        [actionTypes.WISHLIST_ADD_RANGE]: wishlistAddRange,
        [actionTypes.WISHLIST_REMOVE_RANGE]: wishlistRemoveRange
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
